import Link from 'components/ui/AppLink';
import { Footer } from 'components/ui/AppShellFallback';
import { Box, Button, Grid, Typography } from '@mui/material';
import { Radio } from 'components/ui/FormControls';

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { config } from '../../../config';
import { baseUrls } from '../../../utils/baseUrls.utils';
import Container from '../../ui/Container';

import { AppBar } from 'components/ui/AppShellFallback';

enum UnsubscribeResult {
    notSent,
    unsubscribed,
    notUnsubscribed,
}

export const UnsubscribePage = () => {
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const data = params.get('data');
    const [reason, setReason] = useState('');
    const [email, setEmail] = useState('');
    const [unsubscribeResult, setUnsubscribeResult] =
        useState<UnsubscribeResult>(UnsubscribeResult.notSent);
    const reasons = [
        { value: 'too_frequent', label: 'The emails are too frequent' },
        { value: 'not_relevant', label: 'The emails are not relevant to me' },
        {
            value: 'dont_remember',
            label: 'I don’t remember signing up for this',
        },
        { value: 'other', label: 'Other' },
    ];

    const request = (body: any) =>
        fetch(`${config.serverUrl}/unsubscribe`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        })
            .then((r) => r.json())
            .catch((e) => {});

    useEffect(() => {
        request({ data }).then((r) => r?.email && setEmail(r.email));
    }, [data]);

    const unsubscribe = () =>
        request({ data, reason }).then(
            (r) =>
                'status' in r &&
                setUnsubscribeResult(
                    r.status
                        ? UnsubscribeResult.unsubscribed
                        : UnsubscribeResult.notUnsubscribed
                )
        );

    return (
        <>
            <AppBar id="app-header" app="Insights" onSignOut={() => {}} />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'absolute',
                    top: (theme) => theme.spacing(8),
                    bottom: 0,
                    left: 0,
                    right: 0,
                }}
            >
                <Container>
                    <Box sx={{ position: 'relative' }}>
                        <Grid container spacing={4}>
                            <Grid
                                size={{
                                    md: 10,
                                    xs: 12,
                                }}
                            >
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Typography variant="h5" component="h1">
                                            {unsubscribeResult ===
                                            UnsubscribeResult.notSent
                                                ? 'Unsubscribe'
                                                : unsubscribeResult ===
                                                    UnsubscribeResult.unsubscribed
                                                  ? 'You are now unsubscribed.'
                                                  : 'You are already unsubscribed.'}
                                        </Typography>
                                    </Grid>
                                    <Grid size={12}>
                                        <Typography
                                            sx={{
                                                color: 'text.secondary',
                                            }}
                                        >
                                            {unsubscribeResult ===
                                            UnsubscribeResult.notSent
                                                ? 'If you no longer wish to receive any email notifications, unsubscribe below. You can manage notifications for specific channels'
                                                : 'You can resubscribe for email notifications at any time'}{' '}
                                            via{' '}
                                            <Link
                                                to={
                                                    config.basePath +
                                                    baseUrls.emailNotifications
                                                }
                                                ignoreRouter
                                            >
                                                Manage email notifications
                                            </Link>
                                            .
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                {unsubscribeResult ===
                                UnsubscribeResult.notSent ? (
                                    <Grid container spacing={2}>
                                        <Grid size={12}>
                                            <Grid container spacing={1}>
                                                <Grid size={12}>
                                                    <Typography variant="body1">
                                                        {email}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{
                                                            color: 'text.secondary',
                                                        }}
                                                    >
                                                        If you have not
                                                        requested to unsubscribe
                                                        please ignore since the
                                                        email associated with
                                                        this page was most
                                                        likely forwarded to you.
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={12}>
                                            <Grid container spacing={1}>
                                                <Grid size={12}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        component="p"
                                                    >
                                                        I’m unsubscribing
                                                        because:
                                                    </Typography>
                                                </Grid>
                                                {reasons.map((r) => (
                                                    <Grid
                                                        key={r.value}
                                                        size={12}
                                                    >
                                                        <Radio
                                                            value={r.value}
                                                            checked={
                                                                reason ===
                                                                r.value
                                                            }
                                                            label={r.label}
                                                            onChange={(e) =>
                                                                setReason(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                        <Grid size={12}>
                                            <Button
                                                variant="contained"
                                                onClick={unsubscribe}
                                            >
                                                Unsubscribe from all article
                                                alerts
                                            </Button>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Button
                                        variant="contained"
                                        onClick={() =>
                                            (window.location.href =
                                                config.basePath)
                                        }
                                    >
                                        Login to Insights
                                    </Button>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
                <Footer />
            </Box>
        </>
    );
};
